var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"made-by-component text--center pb-3"},[_c('span',[_vm._v("\n      ©"+_vm._s((new Date).getFullYear())+".\n      "),_c('a',{staticClass:"linkIbero",attrs:{"href":"https://www.ibero.edu.co/","target":"_blank"}},[_vm._v("Universidad Iberoamericana")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }